// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'

// Style
import themeColors from 'assets/theme/colors'

export default function IncludedSection() {
  const { t } = useTranslation('solutionsIotAirQualityMonitoring')

  const items = [
    t('included.items.01'),
    t('included.items.02'),
    t('included.items.03'),
    t('included.items.04'),
    t('included.items.05'),
    t('included.items.06'),
    t('included.items.07'),
    t('included.items.08'),
    t('included.items.09'),
    t('included.items.10'),
    t('included.items.11'),
    t('included.items.12'),
    t('included.items.13'),
    t('included.items.14'),
    t('included.items.15')
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader
        eyebrow={t('included.eyebrow')}
        title={t('included.title')}
        intro={[t('included.intro')]}
      />

      <BulletGrid items={items} columns={3} />
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
